<template>
  <div class="container">
    <van-nav-bar :title="$t('withdraw.bind_account_title')">
      <template #left>
        <van-icon name="arrow-left" color="#fff" size="20"  @click="back()"></van-icon>
      </template>
    </van-nav-bar>
    
    <div class="card">
      <!-- <div class="section-title">{{ $t('withdraw.method') }}</div> -->
      <withdraw-info-form v-if="withdrawInfo.length" :fields="withdrawInfo" :form="withdrawForm" />
      <div v-else-if="!configLoading" class="config-error">{{ $t('withdraw.config_error') }}</div>

      <template v-if="!hasPayPassword">
        <div class="row">
          <div class="title">{{ $t('setting.password') }}</div>
          <div class="input_wrap">
            <van-field v-model="paypassword" type="password" :placeholder="$t('setting.password_tip')" />
          </div>
        </div>
        <div class="row">
          <div class="title">{{ $t('setting.password2') }}</div>
          <div class="input_wrap">
            <van-field v-model="paypassword2" type="password" :placeholder="$t('setting.password_tip3')" />
          </div>
        </div>
      </template>
    </div>
    <div class="btn" @click="bindCard()">{{$t("withdraw.bind_account")}}</div>
  </div>
</template>

<script>
import WithdrawInfoForm from '@/common/WithdrawInfoForm.vue';
import {
  buildWithdrawForm,
  parseWithdrawInfo,
  pickCompatBankFields,
  pickWithdrawInfo,
  resolveWithdrawConfig,
  resolveWithdrawFields,
  validateWithdrawForm
} from '@/common/withdrawForm';

export default {
  components: { WithdrawInfoForm },
  data() {
    return {
      withdrawInfo: [],
      withdrawForm: {},
      hasPayPassword: false,
      configLoaded: false,
      configLoading: true,
      paypassword: "",
      paypassword2: "",
      submitting: false
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getWithdrawConfig(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_config'
      }).then(res=>{
        this.configLoading = false;
        if(res && res.code === 200){
          const config = resolveWithdrawConfig(res);
          this.withdrawInfo = resolveWithdrawFields(config);
          const accountInfo = parseWithdrawInfo(config.account && config.account.withdraw_info);
          this.withdrawForm = buildWithdrawForm(this.withdrawInfo, accountInfo);
          this.hasPayPassword = !!config.has_pay_password;
          this.configLoaded = true;
        }else if(res && res.code ===401){
          this.$toast(res.msg);
        }
      }).catch(()=>{
        this.configLoading = false;
      })
    },
    async bindCard(){
      if(this.submitting){
        return false;
      }
      if(!this.configLoaded || !this.withdrawInfo.length){
        this.$toast(this.$t("withdraw.config_error"));
        return false;
      }
      const error = validateWithdrawForm(this.withdrawInfo, this.withdrawForm, {
        required: field => this.$t("withdraw.field_required", { title: field.title }),
        invalid: field => this.$t("withdraw.field_invalid", { title: field.title })
      });
      if(error){
        this.$toast(error);
        return false;
      }
      const withdrawInfo = pickWithdrawInfo(this.withdrawInfo, this.withdrawForm);
      if(!Object.keys(withdrawInfo).length){
        this.$toast(this.$t("withdraw.info_required"));
        return false;
      }

      if(!this.hasPayPassword){
        if(this.paypassword === ""){
          this.$toast(this.$t("setting.password_tip"));
          return false;
        }
        if(this.paypassword2 === ""){
          this.$toast(this.$t("setting.password_tip3"));
          return false;
        }
        if(this.paypassword.length !== 4){
          this.$toast(this.$t("setting.password_tip2"));
          return false;
        }
        if(this.paypassword !== this.paypassword2){
          this.$toast(this.$t("setting.password_tip4"));
          return false;
        }
      }

      this.submitting = true;
      if(!this.hasPayPassword){
        const pwdRes = await this.$http({
          method: 'post',
          data: { paypassword: this.paypassword },
          url: 'user_set_paypw'
        });
        if(!pwdRes || pwdRes.code !== 200){
          this.submitting = false;
          this.$toast((pwdRes && pwdRes.msg) || this.$t("withdraw.config_error"));
          return false;
        }
        this.hasPayPassword = true;
      }

      const compat = pickCompatBankFields(withdrawInfo);
      const bankRes = await this.$http({
        method: 'post',
        data: {
          bankid: compat.bankid,
          bank: compat.bank,
          withdraw_info: JSON.stringify(withdrawInfo)
        },
        url: 'user_set_bank'
      });
      this.submitting = false;
      if(!bankRes || bankRes.code === undefined){
        this.$toast(this.$t("withdraw.config_error"));
        return false;
      }
      this.$toast(bankRes.msg);
      if(bankRes.code === 200){
        this.paypassword = "";
        this.paypassword2 = "";
        setTimeout(() => {
          this.$router.replace('/Withdraw');
        }, 800);
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getWithdrawConfig();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container{
  min-height: 100%;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
}

.van-nav-bar {
  background: linear-gradient(120deg, #f3a3c4 0%, #c3a6f0 55%, #ffb894 100%);
  height: 2.88rem;
  position: relative !important;

  /deep/ .van-nav-bar__title{
    color: #fff;
    font-size: 1rem;
  }
  /deep/ .van-nav-bar__left{
    padding: 0 1rem;
  }
}


.van-cell {
  font-size: 2.00rem;
  line-height: 5.00rem;
}

.card{
  margin: 0.9rem 4% 0;
  padding: 1rem 1rem 0.3rem;
  background: #fff;
  border-radius: 1.2rem;
  box-shadow: 0 0.4rem 1.1rem rgba(183, 156, 236, 0.16);
  .section-title{
    color: #442b89;
    font-size: 0.9rem;
  }
  .config-error{
    margin-top: 0.5rem;
    font-size: 0.88rem;
    color: #969799;
  }
  .title{
    color: #4a3a5c;
    font-size: 0.88rem;
    margin-top: 4.5%;
  }
  .input_wrap{
    background-color: #fff !important;
    background: #fff;
    border-radius: 0.9rem;
    border: 1px solid #f0e2f2;
    height: 3.00rem;
    margin-top: 3%;
    margin-bottom: 4.5%;
    color: #323233;
    display: flex;
    align-items: center;
  }
  
  .van-field{
    background-color: transparent;
    padding: 0 1.25rem;

    color: #4a3a5c;
    &::-webkit-input-placeholder {
      color: #323233;
    }
    font-size: 0.88rem;
    display: flex;
    align-items: center;
    border-bottom: 0 !important;
    border: none;
    height: 1.50rem;
    /deep/ .van-field__control{
      color: #323233;
      background-color: transparent;
    }
    /deep/ .van-field__value{
      width: 100%;
      height: 100%;
      line-height: 2rem;
    }


     
    /deep/ .van-field__body{
      height: 1.50rem;
    }
     
  }
}
.btn{
  display: block;
  width: 92%;
  margin: 1rem auto 2rem;
  background: linear-gradient(120deg, #f7a1c0 0%, #c3a3f2 55%, #ffbe9c 100%);
  box-shadow: 0 0.3rem 0.9rem rgba(245, 154, 184, 0.35);
  color: #fff;
  padding: .86667rem 0;
  border-radius: 0.9rem;
  font-size: .93333rem;
  cursor: pointer;
  text-align: center;
}
</style>
